import { type MCPServerInfo } from '../../types';

const SalesforceRemoteServer: MCPServerInfo = {
  serverId: 'SALESFORCE_REMOTE',
  name: 'Salesforce',
  slug: 'salesforce-remote',
  description: 'Salesforce remote MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl:
      'https://api.salesforce.com/platform/mcp/v1/platform/sobject-all'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
  // authConfig: {
  //   requiredScopes: ['mcp_api', 'refresh_token'],
  //   creds: {
  //     clientId: {
  //       type: 'string',
  //       sensitive: false,
  //       envKey: 'SALESFORCE_CLIENT_ID'
  //     },
  //     clientSecret: {
  //       type: 'string',
  //       sensitive: true,
  //       envKey: 'SALESFORCE_CLIENT_SECRET'
  //     }
  //   }
  // }
};

export default SalesforceRemoteServer;
